import React from 'react';
import I18n from 'i18n-js';
import * as Routes from 'modules/routes';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';

interface NewVocabularyGamesLinkProps {
  lessonId: number;
  programId: number;
}

const NewVocabularyGamesLink = ({ lessonId, programId }: NewVocabularyGamesLinkProps) => (
  <div className="tw-flex tw-items-center tw-gap-2 tw-mt-6">
    <Icon className="tw-text-orange" icon="Games" size={25} />
    <Text className="tw-bg-white" size="sm" tag="p" weight="semibold">
      {I18n.t('check_out_our')}
      {' '}
      <a
        className="tw-font-bold"
        href={Routes.library_shared_program_games_path(programId, { lesson_games: true, lesson_id: lessonId })}
      >
        <Text className="tw-bg-white" size="sm" tag="span"> {I18n.t('vocabulary_game')}! </Text>
      </a>
    </Text>
  </div>
);

export default NewVocabularyGamesLink;
